// extracted by mini-css-extract-plugin
export default {"progress":"progress_progress__zehQZ","progressSvg":"progress_progressSvg__TAHbc","progressCircle":"progress_progressCircle__Xwnkd","progressText":"progress_progressText__IYhwj"};